// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ApplicationController from "./application_controller"
application.register("application", ApplicationController)

import Backend__ApplicationController from "./backend/application_controller"
application.register("backend--application", Backend__ApplicationController)

import Backend__FlashController from "./backend/flash_controller"
application.register("backend--flash", Backend__FlashController)

import Backend__FormController from "./backend/form_controller"
application.register("backend--form", Backend__FormController)

import Backend__MarkdownEditorController from "./backend/markdown_editor_controller"
application.register("backend--markdown-editor", Backend__MarkdownEditorController)

import Backend__RemoteFormController from "./backend/remote_form_controller"
application.register("backend--remote-form", Backend__RemoteFormController)

import Backend__SidebarController from "./backend/sidebar_controller"
application.register("backend--sidebar", Backend__SidebarController)

import ClassTogglerController from "./class_toggler_controller"
application.register("class-toggler", ClassTogglerController)

import GsnNumberFormatterController from "./gsn_number_formatter_controller"
application.register("gsn-number-formatter", GsnNumberFormatterController)

import LeaderboardLoaderController from "./leaderboard_loader_controller"
application.register("leaderboard-loader", LeaderboardLoaderController)

import SelectpickerController from "./selectpicker_controller"
application.register("selectpicker", SelectpickerController)
